import produce from 'immer';
import { ActionTypes } from '../actions/app';

export const initialState = {
    categories: [],
    destinations: [],
    tick: 0,
    isFirstRender: true,
    prefetchProgress: { total: 0, loaded: 0, loading: false },
};

/* eslint-disable no-param-reassign */
function appReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.SET_CATEGORIES:
                draft.categories = action.categories;
                return draft;
            case ActionTypes.SET_DESTINATIONS:
                draft.destinations = action.destinations;
                return draft;
            case ActionTypes.TICK:
                draft.tick = draft.tick ^ 1;
                return draft;
            case ActionTypes.SET_IS_FIRST_RENDER:
                draft.isFirstRender = action.isFirstRender;
                return draft;
            case ActionTypes.SET_PREFETCH_PROGRESS:
                draft.prefetchProgress.total = action.total;
                draft.prefetchProgress.loaded = action.loaded;
                draft.prefetchProgress.loading = action.loading;
                return draft;
            default:
                return draft;
        }
    });
}

export default appReducer;
